import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import inovaImage from "../../../assets/inova@2x.png";

// ARQUIVO PDF
function motoristasPDF(marc) {
  pdfMake.vfs = pdfFonts.pdfMake.vfs;

  // RODAPÉ SUPERIOR
  const reportTitle = [
    {
      text: "Lista de Usuários",
      fontSize: 15,
      bold: true,
      margin: [250, 14, 0, 15],
    },
  ];
  // --------------------------------------------





  // + FORMATAÇÃO DA COLUNA NIVEL DE ACESSO  || DADOS DO PDF(TABELA)*
/*+*/ const dados = marc.map((motorista) => {
  const Formatacao =
    motorista.tipo === "a"
      ? "Administrador"
      : motorista.tipo === "u"
        ? "Usuário"
        : "";
// ----------------------------------------------------- +
  return [
    { text: (motorista.nome || "").toUpperCase(), fontSize: 9, margin: [0, 2, 0, 2] },
    { text: motorista.email || "", fontSize: 9, margin: [0, 2, 0, 2] },
    // { text: motorista.grupos || "", fontSize: 9, margin: [0, 2, 0, 2] },
    { text: Formatacao ,fontSize: 9, margin: [0, 2, 0, 2] }, 
    //            
    { text: motorista.obs || "", fontSize: 9, margin: [0, 2, 0, 2] }, // campo de observação
  ];
});
  // ----------------------------------------------------- *

  const details = [
    {
      table: {
        headerRows: 1,
        widths: [200, 200, 200, 200, 200, "*"],

        body: [
          [
            { text: "Nome", bold: true, fontSize: 10 },
            { text: "Email", bold: true, fontSize: 10 },
            // { text: "Grupos", bold: true, fontSize: 10 },
            { text: "Nível de acesso", bold: true, fontSize: 10 },
            // { text: "Veículos", bold: true, fontSize: 10 },
            { text: "Observação", bold: true, fontSize: 10 },
          ],
          ...dados,
        ],
      },
      layout: {
        hLineWidth: function (i) {
          return i === 0 ? 1.5 : 0.5;
        },
        vLineWidth: function () {
          return 0;
        },
        hLineColor: function () {
          return "#000";
        },
        paddingLeft: () => 2,
        paddingRight: () => 2,
        paddingTop: () => 4,
        paddingBottom: () => 4,
      },
    },
  ];

  const rodape = (currentPage, pageCount) => {
    return {
      text: `Página ${currentPage} de ${pageCount}`,
      alignment: "left",
      fontSize: 8,
      margin: [40, 10, 0, 0],
    };
  };

  const img = new Image();
  img.src = inovaImage;
  img.onload = function () {
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    canvas.width = img.width;
    canvas.height = img.height;
    ctx.drawImage(img, 0, 0);
    const dataUrl = canvas.toDataURL("image/png");

    const docDefinitions = {
      pageSize: "A4",
      pageOrientation: "landscape",
      pageMargins: [13, 5, 10, 40],
      content: [
        {
          columns: [
            { image: dataUrl, width: 80 },
            { stack: reportTitle, margin: [0, 0, 0, 0] },
          ],
        },
        ...details,
      ],
      footer: rodape,
    };

    pdfMake.createPdf(docDefinitions).download();
  };
}

export default motoristasPDF;
